// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.provider{\n    position: relative;\n    top: 0px;\n}\n.wagering-table{\n        height: auto;\n        width: 100%;\n    }\n\n.wageering-template-checkbox{\n    float: left;\n    cursor: pointer;\n}\n.small-size-error{\n    font-size: 13px;\n}\n.wagering-template-save-button{\n    position: relative;\n    top: 32px;\n}\n\n.wagering-table tr td input {\n    margin-left: 12px;\n}", ""]);
// Exports
module.exports = exports;
